import Container from 'react-bootstrap/Container';
import React, { useState, useEffect } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Row, Col, Image, ButtonGroup, Offcanvas } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faFacebook, faInstagram, faYoutube, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faPhone, faMapLocationDot, faMapLocation, faAddressCard, faAddressBook } from '@fortawesome/free-solid-svg-icons';
import { Carousel } from 'react-bootstrap';
import axios  from 'axios';
import { serverurl } from '../../providers/ServerUrl';
import { EventCountDownTimer } from '../../components/EventCountDownTimer';

import './NavBar.css';

export function NavBar() {

  const [mynavbar, setMyNavBar] = useState(false);
  const [news, setNews] = useState([]);
  const [nextevent, setNextEvent] = useState([]);


  /*const changeBackground = () => {
    if (window.scrollY >= 50) {
      setMyNavBar(true);
    } else {
      setMyNavBar(false);
    }
  }*/


  ///window.addEventListener('scroll', changeBackground);

  const fetchNewsData = () => {
    return axios.get(serverurl+"/api/news")
        .then((response) => setNews(response.data['news']));
  };

  const fetchNextEventData = () => {
    return axios.get(serverurl + "/api/nextevent")
        .then((response) => setNextEvent(response.data['event']));
  };

  useEffect(() => {
    fetchNewsData();
    fetchNextEventData();

 },[]);

 
 //let user = JSON.parse(localStorage.getItem('user'));
 const navigate = useNavigate();
  return (

    <>

      <div className="sub-header" id="sub-header">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col md={6} xs={12} className="text-center text-md-start mb-2 mb-md-0">
              <p style={{ margin: '0px' }} id="subheadertop" className="topbar-welcome-text">
                WELCOME TO ADEAJALA MINISTRIES                
              </p>
            </Col>
            <Col md={6} xs={12} className="text-center text-md-end">
              <div style={{ color: '#fff', margin: '0px' }} id="subheadernews" className="topbar-social-wrap">
                <Link to="#" className='topbar-social-link' id="socialbtnnav" aria-label="Facebook">
                  <FontAwesomeIcon icon={faFacebook} id='icon' />
                </Link>
                <Link to="#" className='topbar-social-link' id="socialbtnnav" aria-label="Instagram">
                  <FontAwesomeIcon icon={faInstagram} id='icon' />
                </Link>
                <Link to="#" className='topbar-social-link' id="socialbtnnav" aria-label="Twitter">
                  <FontAwesomeIcon icon={faTwitter} id='icon' />
                </Link>
                <Link to="#" className='topbar-social-link' id="socialbtnnav" aria-label="YouTube">
                  <FontAwesomeIcon icon={faYoutube} id='icon' />
                </Link>
                <Link to="#" className='topbar-social-link' id="socialbtnnav" aria-label="LinkedIn" style={{ display:'none' }}>
                  <FontAwesomeIcon icon={faLinkedin} id='icon' />
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="sub-headermiddle" id="sub-headermiddle" style={{ backgroundColor:'#135592' }}>
        <Container>
          <Row className="align-items-center">
            <Col md={5} sm={12} className="text-center text-md-start mb-1 mb-md-0">
              <p style={{ margin: '0px' }} id="subheadertop" className="topbar-contact-item text-md-start">
                <FontAwesomeIcon icon={faAddressBook} style={{ color:'#fff' }} id='icon'/>
                &nbsp;
                <span style={{ color: '#fff' }}>1391, Oswego Street, Aurora CO 80010</span>
              </p>
            </Col>
            <Col md={4} sm={12} className="text-center mb-1 mb-md-0">
              <p style={{ margin: '0px' }} id="subheadertop" className="topbar-contact-item text-center">
                <FontAwesomeIcon icon={faEnvelope} style={{ color:'#fff' }} id='icon'/>
                &nbsp;
                <span style={{ color: '#fff' }}>infoaam@adeajalaministries.org</span>             
              </p>
            </Col>
            <Col md={3} sm={12} className="text-center text-md-end">
              <p style={{ margin: '0px' }} id="subheadertop" className="topbar-contact-item text-md-end">
                <FontAwesomeIcon icon={faPhone} style={{ color:'#fff' }} id='icon'/>
                &nbsp;
                <span style={{ color: '#fff' }}>+1-720-859-1737</span>               
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="sub-headerbottom" id="sub-headerbottom" style={{ backgroundColor:'#323232' }}>
      <Container>
          <Row className="align-items-center g-2">
            <Col sm={6} xs={12} className="text-center text-sm-start mb-1 mb-sm-0">
              <Carousel indicators={false} controls={false} interval={4000} className="topbar-news-carousel">
              { news && news.length > 0 && news.map((newsData, idx) => {
                return <Carousel.Item key={idx}>
                  <p className="topbar-news-text">{
                   newsData.news_title }
                  </p>
                </Carousel.Item>
               })
              }
              </Carousel>
            </Col>
            <Col sm={6} xs={12} className="text-center text-sm-end">
               <div className="topbar-event-align-wrap">
               {
                nextevent && nextevent.length > 0 ? (
                 nextevent.map((nextEventData,index) => {
                 return (
                 <React.Fragment key={index}>
                 {
                 nextEventData.events_title !== "" ?
                   <div style={{ color:'#fff', margin:'0' }}>
                      <Row className="align-items-center justify-content-center justify-content-sm-end g-2">
                       <Col xs="auto"><p id='nextevent' style={{ color:"white", margin: 0 }}>NEXT EVENT IN:</p></Col>
                       <Col xs="auto">
                         <EventCountDownTimer eventcountdown = {nextEventData.events_countdown}/>
                        </Col>
                      </Row>
                    </div>
                  :
                  <p className="no-upcoming-event-pill">NO UPCOMING EVENTS</p>
                 }
                 </React.Fragment>
                 );
                 })
                ) : (
                  <p className="no-upcoming-event-pill">NO UPCOMING EVENTS</p>
                )
               }
               </div>
              
            </Col>
          </Row>
        </Container>
      </div>


      <div className="navbar-area">
        <Navbar collapseOnSelect expand="lg" style={{ padding: '20px' }}
          className='mynavbar'>
          <Container className='navbarContainer'>
            
            <Navbar.Brand href="/">
              <Image fluid src={mynavbar ? "images/logoaam.png" : "images/logoaam.png"}
                id="logo"
                alt="Logo" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="offcanvasNavbar-expand-lg" id='mynavbartoggle' />
            <Navbar.Offcanvas
              id="offcanvasNavbar-expand-lg"
              aria-labelledby="offcanvasNavbarLabel-expand-lg"
              placement="end"
              className="mobile-nav-drawer"
            >
              <Offcanvas.Header closeButton className="mobile-drawer-header">
                <Offcanvas.Title id="offcanvasNavbarLabel-expand-lg">
                  <Image src="images/logoaam.png" alt="Logo" style={{ height: '50px', width: 'auto' }} />
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body className="mobile-drawer-body">
                <Nav className="me-auto" id="me-auto">
                  <Nav.Link href="/" className='navLink' id="navLink">HOME</Nav.Link>
                  <Nav.Link href="/about" className='navLink' id="navLink">ABOUT</Nav.Link>
                  <Nav.Link href="/sermons" className='navLink' id="navLink">MESSAGES</Nav.Link>
                  <Nav.Link href="/podcasts" className='navLink' id="navLink">PODCAST</Nav.Link>
                  <Nav.Link href="https://adeajalaministries.org/aamstore" className='navLink' id="navLink">E-STORE</Nav.Link>
                  <Nav.Link href="/livestream" className='navLink' id="navLink">LIVE STREAM</Nav.Link>
                  <Nav.Link href="/events" className='navLink' id="navLink">EVENT</Nav.Link>
                  <Nav.Link href="/kcile" className='navLink' id="navLink">KCILE</Nav.Link>
                  <Nav.Link href="/contactus" className='navLink' id="navLink">CONTACT US</Nav.Link>
                  <Nav.Link href="/publications" className='navLink' id="navLink">PUBLICATIONS</Nav.Link>
                </Nav>
                <Nav className="mt-3 mt-lg-0">       
                  <Nav.Link href="/give" className='btn btn-primary give-drawer-btn' style={{ borderRadius: '5px', backgroundColor: 'red', fontWeight: '700', fontSize: '18px', color:'#fff' }} id="givenavlink">GIVE</Nav.Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      </div>
    </>
  );
}

